export const BOARD_SETTINGS = {
  WIDTH: 800,
  HEIGHT: 600,
  PLAYER_GAP_FROM_WALL: 54,
}

export const COLORS = {
  PRIMARY: '#9b4646',
  PRIMARY_DARK: '#893737',
  HIGHLIGHT: '#d9dd2a',
  LIGHT: '#ffffff',
  DARK: '#000000',
}

export const FONTS = {
  PRIMARY: 'Rubik Mono One, monospace',
}

export const BALL = {
  RADIUS: 10,
}

export const PLAYER_TYPE = {
  USER: 'user',
  MACHINE: 'machine',
}
